/**
 * Automatically sets the `viewBox` attribute on an SVG element based on its actual bounding box.
 *
 * This is useful when you want the SVG's `viewBox` to match its rendered content,
 * making it scale properly in responsive layouts or when embedded dynamically.
 *
 * @param {SVGSVGElement | null} svg - The SVG element to update. If `null` or not an SVG element, nothing happens.
 */
export function autoSetViewBox(svg: SVGSVGElement | null): void {
	if (!svg) return;

	const bbox = svg.getBBox();
	const viewBox = [bbox.x, bbox.y, bbox.width, bbox.height].join(" ");
	svg.setAttribute("viewBox", viewBox);
}
